import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DealerProps } from "../../../../store/modules/DealerCare/types.store";
import image from "../../assets/image.png";
import * as Styled from "./styles";

export interface DealerResaleInfoProps {
  dealerData: DealerProps | null;
}

const DealerResaleInfo: React.FC<DealerResaleInfoProps> = ({ dealerData }) => {
  const { t } = useTranslation();

  const isResaleOpen = dealerData?.enabled;
  return (
    <Styled.Container>
      <Styled.Header>
        <Styled.HeaderLeft>
          <Styled.ImageContainer>
            <Styled.StyledImage src={image} alt="Dealer illustration" />
          </Styled.ImageContainer>
          <Typography variant="h5">{t("resaleInformation")}</Typography>
        </Styled.HeaderLeft>
        <Styled.StatusChip>
          {isResaleOpen ? (
            <Styled.ChipOpen label={t("resaleOpen")} size="small" />
          ) : (
            <Styled.ChipClose label={t("resaleClose")} size="small" />
          )}
        </Styled.StatusChip>
      </Styled.Header>

      <Styled.CompanyNameContainer>
        <Styled.CompanyNameTypography variant="h5">
          {dealerData?.tradeName || "-"}
        </Styled.CompanyNameTypography>
      </Styled.CompanyNameContainer>
    </Styled.Container>
  );
};

export default DealerResaleInfo;
